export default __webpack_public_path__ + "static/media/logo.932b0f8e.png";